import {RefObject, useEffect} from "react";

interface IProps {
    tableRef: RefObject<HTMLElement | null>;
    headerRef: RefObject<HTMLElement | null>;
}

export const useSyncScroll = (props: IProps) => {
    useEffect(() => {
        const headerWrap = props.headerRef.current;
        const tableWrap = props.tableRef.current;

        if (headerWrap && tableWrap) {
            const syncHeaderScroll = () => {
                const headerContent = props.headerRef.current;
                const tableContent = props.tableRef.current;

                if (headerContent && tableContent) {
                    tableContent.scrollLeft = headerContent.scrollLeft;
                }
            };

            const syncTableScroll = () => {
                const headerContent = props.headerRef.current;
                const tableContent = props.tableRef.current;

                if (headerContent && tableContent) {
                    headerContent.scrollLeft = tableContent.scrollLeft;
                }
            };

            headerWrap.addEventListener("scroll", syncHeaderScroll);
            tableWrap.addEventListener("scroll", syncTableScroll);
            syncTableScroll();

            return () => {
                headerWrap.removeEventListener("scroll", syncHeaderScroll);
                tableWrap.removeEventListener("scroll", syncTableScroll);
            };
        }
    }, [props.headerRef.current, props.tableRef.current]);
};
import {RefObject, useEffect} from "react";

interface IProps {
    tableRef: RefObject<HTMLElement | null>;
    headerRef: RefObject<HTMLElement | null>;
}

export const useSyncScroll = (props: IProps) => {
    useEffect(() => {
        const headerWrap = props.headerRef.current;
        const tableWrap = props.tableRef.current;

        if (headerWrap && tableWrap) {
            const syncHeaderScroll = () => {
                const headerContent = props.headerRef.current;
                const tableContent = props.tableRef.current;

                if (headerContent && tableContent) {
                    tableContent.scrollLeft = headerContent.scrollLeft;
                }
            };

            const syncTableScroll = () => {
                const headerContent = props.headerRef.current;
                const tableContent = props.tableRef.current;

                if (headerContent && tableContent) {
                    headerContent.scrollLeft = tableContent.scrollLeft;
                }
            };

            headerWrap.addEventListener("scroll", syncHeaderScroll);
            tableWrap.addEventListener("scroll", syncTableScroll);
            syncTableScroll();

            return () => {
                headerWrap.removeEventListener("scroll", syncHeaderScroll);
                tableWrap.removeEventListener("scroll", syncTableScroll);
            };
        }
    }, [props.headerRef.current, props.tableRef.current]);
};
